import { createStore } from 'vuex'
import { getSelfProfile, getSelfTeam, updateAvatarUrl, getSelfQQState } from './api'
import { QQ, TeamOwned, UserProfile } from './models'

export interface State {
  user: UserProfile | null
  team: TeamOwned | null
  avatarUpdate: number
  teamAvatarUpdate: number
  qq: QQ | null
}

const store = createStore<State>({
  state(): State {
    return {
      user: null,
      team: null,
      avatarUpdate: 0,
      teamAvatarUpdate: 0,
      qq: null
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setTeam(state, team) {
      state.team = team
    },
    resetUser(state) {
      state.user = null
    },
    resetTeam(state) {
      state.team = null
    },
    updateAvatarUrl(state) {
      state.avatarUpdate++
    },
    updateTeamAvatarUrl(state) {
      state.teamAvatarUpdate++
    },
    refreshInviteCode(state, invite) {
      state.team!.invite = invite
    },
    setQQ(state, qq) {
      state.qq = qq
    }
  },
  actions: {
    async getSelfProfile({ commit }) {
      commit('setUser', await getSelfProfile())
    },
    async getSelfTeam({ commit }) {
      commit('setTeam', await getSelfTeam())
    },
    async getSelfQQ({ commit }) {
      commit('setQQ', await getSelfQQState())
    }
  }
})

export default store
